import { HttpClient, HttpHeaders, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { TextMessage, MediaMessage } from '../models/chat.state';
import axios from 'axios';

@Injectable({
    providedIn: 'root'
    })
export class ChatServerService {
    constructor(private http: HttpClient, private router: Router) {}

    loadChat(service_id: number): Observable<any> {
     
        return this.http.get(`${environment.apiUrl}/chat/getMessages/${service_id}`);
    }

    sendMessage(message: TextMessage): Observable<any> {
        return this.http.post(`${environment.apiUrl}/chat/sendMessage`, message);
    }

    getMediaUploadUrl(service_id: number, file_name: string): Observable<any> {
       
        return this.http.post(`${environment.apiUrl}/chat/getMediaUploadUrl`, { service_id, file_name });
    }

    // uploadFileToServer(preSignedUrlBase64: string, file?: File, contentType?: string): Observable<any> {
   
  
    //   const httpOptions = {
    //     headers: new HttpHeaders({
    //       'Content-Type': contentType || 'application/octet-stream'
    //     })
    //   };
  
    //   // Usar el PreSigned URL decodificado en la petición HTTP
    //   return this.http.put(preSignedUrlBase64, file, httpOptions);
    // }

    //with axios
    async uploadMediaToS3(preSignedUrl: string, file: File, contentType: string): Promise<void> {
     
      try {
        const response = await axios.put(preSignedUrl, file, {
          headers: {
            'Content-Type': contentType || 'application/octet-stream',
          },
        });
    
      } catch (error) {
        console.error('Error al subir la imagen:', error);
      }
    }

    sendMediaMessage(mediaMessage: MediaMessage): Observable<any> {
        return this.http.post(`${environment.apiUrl}/chat/sendMediaMessage`, mediaMessage);
    }

}